import type { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

/**
 * Filters an observable of a list to return only non-empty lists.
 */
export function notEmpty<T>(): (
  source$: Observable<readonly T[]>,
) => Observable<readonly T[]> {
  return filter(xs => xs.length > 0);
}
